import { get, values } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPackageSkus = get('inventory.packageSkus');

export const getSkusByPackageId = createSelector(
  getPackageSkus,
  get('byPackageId')
);

export const getSkusForPackageId = createSelector(
  (_, packageId) => packageId,
  getSkusByPackageId,
  get
);

export const getSkusListForPackageId = createSelector(
  getSkusForPackageId,
  values
);

export const getIsFetching = createSelector(getPackageSkus, get('fetching'));
export const getIsFetched = createSelector(getPackageSkus, get('fetched'));
export const getFetchingError = createSelector(
  getPackageSkus,
  get('fetchingError')
);

export const getIsSaving = createSelector(getPackageSkus, get('saving'));
export const getIsSaved = createSelector(getPackageSkus, get('saved'));
export const getSavingError = createSelector(
  getPackageSkus,
  get('savingError')
);

export const getIsDeleting = createSelector(getPackageSkus, get('deleting'));
export const getIsDeleted = createSelector(getPackageSkus, get('deleted'));
export const getDeletingError = createSelector(
  getPackageSkus,
  get('deletingError')
);
